import React, { useEffect, useState, useCallback } from 'react'
import { TextField, Grid, Box, Button,FormHelperText } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsSixSchema } from '../../Utils/Validations'
import FileValidations from '../FileValidation/FileValidations'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
const DriveWithUsSix = ({ handleBack, handleComplete, driveUsData, setDriveUsData }) => {
  const { CheckFile, fileError } = FileValidations()
  const [vehicle_reg_expiry, setVehicle_reg_expiry] = React.useState(null);
  const [vehicle_reg_pic, setVehicle_reg_pic] = useState()
  
  const { handleSubmit, control, formState: { errors },setValue } = useForm({
    resolver: yupResolver(DriveUsSixSchema)
  })

  useEffect(()=>{
    setValue("vehicle_reg_expiry",driveUsData.vehicle_reg_expiry||null)
    setValue("vehicle_reg_plate",driveUsData.vehicle_reg_plate||null)
    setValue("vehicle_reg_pin",driveUsData.vehicle_reg_pin||null)
  },[driveUsData.vehicle_reg_expiry, driveUsData.vehicle_reg_plate, driveUsData.vehicle_reg_pin, setValue])

  const handleDateChange = useCallback((newValue, onChange) => {
    setVehicle_reg_expiry(newValue);
    onChange(newValue);
  }, []);


  const onSubmit = (data) => {
    if (Object.keys(fileError).length === 0) {
      console.log(data)
      setDriveUsData((prev) => ({ ...prev, vehicle_reg_pic: vehicle_reg_pic, vehicle_reg_expiry: vehicle_reg_expiry,vehicle_reg_plate:data.vehicle_reg_plate,vehicle_reg_pin:data.vehicle_reg_pin  }))

      handleComplete()
    }

  }
  const onChangeFiles = (file, name) => {
    if (!file) {
      console.warn('No file selected');
      return;
    }

    // Use setTimeout to handle file processing asynchronously without blocking the form
    setTimeout(() => {
      try {
        CheckFile(file, name);
        
        if (name === "vehicle_reg_pic") {
          setVehicle_reg_pic(file)
        }
      } catch (error) {
        console.error('Error handling file selection:', error);
      }
    }, 50); // Small delay for mobile devices
  }
  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="vehicle_reg_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
               <label>Vehicle Registration</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        onChangeFiles(file, "vehicle_reg_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.vehicle_reg_pic || fileError?.vehicle_reg_pic} 
                  helperText={errors?.vehicle_reg_pic?.message || fileError?.vehicle_reg_pic?.message} 
                />
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>
               
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="vehicle_reg_expiry"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
              <label>Vehicle Registration Expiry</label>
              <DatePicker
                  sx={{width:"100%"}}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleDateChange(newValue, onChange)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.vehicle_reg_expiry,
                      helperText: errors.vehicle_reg_expiry?.message
                    }
                  }}
                />
               
               {errors.vehicle_reg_expiry?<FormHelperText component="p" sx={{color:"#d32f2f",px:1.5}} >{errors.vehicle_reg_expiry?.message}</FormHelperText>:null}
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0},mt:3}} >
          <Controller
            control={control}
            name="vehicle_reg_plate"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
              <label>Plate number</label>
              <TextField fullWidth type="text" value={value} onBlur={onBlur} inputProps={{ onChange: (e) => { onChange(e) } }} error={errors?.vehicle_reg_plate } helperText={errors?.vehicle_reg_plate?.message } on />
               
              
              </>
            )}
          />
          


        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0},mt:3}} >
          <Controller
            control={control}
            name="vehicle_reg_pin"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
              <label>Vin number</label>
              <TextField fullWidth type="text" value={value} onBlur={onBlur} inputProps={{ onChange: (e) => { onChange(e) } }} error={errors?.vehicle_reg_pin } helperText={errors?.vehicle_reg_pin?.message } on />
               
               
              </>
            )}
          />
          


        </Grid>
       
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:3 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%",  border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%",  border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsSix